// @generated by protoc-gen-es v2.10.1 with parameter "target=ts,json_types=true"
// @generated from file onboarding/v1/onboarding.proto (package onboarding.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import { file_common_v1_annotations } from "../../common/v1/annotations_pb";
import type { Any, AnyJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { StepTemplate, StepTemplateJson, WorkflowTemplate, WorkflowTemplateJson } from "./builder_pb";
import { file_onboarding_v1_builder } from "./builder_pb";
import type { SkipStepPayload, SkipStepPayloadJson, StepData, StepDataJson, StepType, StepTypeJson, WorkflowType, WorkflowTypeJson } from "./steps_pb";
import { file_onboarding_v1_steps } from "./steps_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file onboarding/v1/onboarding.proto.
 */
export const file_onboarding_v1_onboarding: GenFile =
	/*@__PURE__*/
	fileDesc(
		"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",
		[file_common_v1_annotations, file_google_protobuf_any, file_google_protobuf_timestamp, file_onboarding_v1_builder, file_onboarding_v1_steps],
	);

/**
 * GetOrCreateWorkflowRunRequest identifies which onboarding workflow to retrieve or create.
 *
 * @generated from message onboarding.v1.GetOrCreateWorkflowRunRequest
 */
export type GetOrCreateWorkflowRunRequest = Message<"onboarding.v1.GetOrCreateWorkflowRunRequest"> & {
	/**
	 * org_id identifies the organization for the workflow.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId: string;

	/**
	 * template_key identifies the workflow template.
	 *
	 * @generated from field: string template_key = 3;
	 */
	templateKey: string;
};

/**
 * GetOrCreateWorkflowRunRequest identifies which onboarding workflow to retrieve or create.
 *
 * @generated from message onboarding.v1.GetOrCreateWorkflowRunRequest
 */
export type GetOrCreateWorkflowRunRequestJson = {
	/**
	 * org_id identifies the organization for the workflow.
	 *
	 * @generated from field: string org_id = 1;
	 */
	orgId?: string;

	/**
	 * template_key identifies the workflow template.
	 *
	 * @generated from field: string template_key = 3;
	 */
	templateKey?: string;
};

/**
 * Describes the message onboarding.v1.GetOrCreateWorkflowRunRequest.
 * Use `create(GetOrCreateWorkflowRunRequestSchema)` to create a new message.
 */
export const GetOrCreateWorkflowRunRequestSchema: GenMessage<GetOrCreateWorkflowRunRequest, { jsonType: GetOrCreateWorkflowRunRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 0);

/**
 * GetOrCreateWorkflowRunResponse returns the run snapshot plus current and next step context.
 *
 * @generated from message onboarding.v1.GetOrCreateWorkflowRunResponse
 */
export type GetOrCreateWorkflowRunResponse = Message<"onboarding.v1.GetOrCreateWorkflowRunResponse"> & {
	/**
	 * run is the full workflow snapshot after the operation.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRun;

	/**
	 * prev_step is the previous step if present.
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRun;

	/**
	 * step is the current active step if present.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRun;

	/**
	 * next_step is the upcoming step once the current step completes.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRun;
};

/**
 * GetOrCreateWorkflowRunResponse returns the run snapshot plus current and next step context.
 *
 * @generated from message onboarding.v1.GetOrCreateWorkflowRunResponse
 */
export type GetOrCreateWorkflowRunResponseJson = {
	/**
	 * run is the full workflow snapshot after the operation.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRunJson;

	/**
	 * prev_step is the previous step if present.
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRunJson;

	/**
	 * step is the current active step if present.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRunJson;

	/**
	 * next_step is the upcoming step once the current step completes.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRunJson;
};

/**
 * Describes the message onboarding.v1.GetOrCreateWorkflowRunResponse.
 * Use `create(GetOrCreateWorkflowRunResponseSchema)` to create a new message.
 */
export const GetOrCreateWorkflowRunResponseSchema: GenMessage<GetOrCreateWorkflowRunResponse, { jsonType: GetOrCreateWorkflowRunResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 1);

/**
 * GetWorkflowRunRequest looks up a workflow run by its identifier.
 *
 * @generated from message onboarding.v1.GetWorkflowRunRequest
 */
export type GetWorkflowRunRequest = Message<"onboarding.v1.GetWorkflowRunRequest"> & {
	/**
	 * workflow_run_id is the run identifier to fetch.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId: string;

	/**
	 * key is the workflow run key identifier.
	 *
	 * @generated from field: string key = 2;
	 */
	key: string;

	/**
	 * user_id is the user identifier for the request.
	 *
	 * @generated from field: string user_id = 3;
	 */
	userId: string;

	/**
	 * org_id is the organization identifier for the request.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;
};

/**
 * GetWorkflowRunRequest looks up a workflow run by its identifier.
 *
 * @generated from message onboarding.v1.GetWorkflowRunRequest
 */
export type GetWorkflowRunRequestJson = {
	/**
	 * workflow_run_id is the run identifier to fetch.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId?: string;

	/**
	 * key is the workflow run key identifier.
	 *
	 * @generated from field: string key = 2;
	 */
	key?: string;

	/**
	 * user_id is the user identifier for the request.
	 *
	 * @generated from field: string user_id = 3;
	 */
	userId?: string;

	/**
	 * org_id is the organization identifier for the request.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;
};

/**
 * Describes the message onboarding.v1.GetWorkflowRunRequest.
 * Use `create(GetWorkflowRunRequestSchema)` to create a new message.
 */
export const GetWorkflowRunRequestSchema: GenMessage<GetWorkflowRunRequest, { jsonType: GetWorkflowRunRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 2);

/**
 * GetWorkflowRunResponse returns the run snapshot plus contextual step data.
 *
 * @generated from message onboarding.v1.GetWorkflowRunResponse
 */
export type GetWorkflowRunResponse = Message<"onboarding.v1.GetWorkflowRunResponse"> & {
	/**
	 * run is the requested workflow snapshot.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRun;

	/**
	 * prev_step is the previous step if present.
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRun;

	/**
	 * step reflects the step at the run's current position.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRun;

	/**
	 * next_step previews the step after the current one if available.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRun;
};

/**
 * GetWorkflowRunResponse returns the run snapshot plus contextual step data.
 *
 * @generated from message onboarding.v1.GetWorkflowRunResponse
 */
export type GetWorkflowRunResponseJson = {
	/**
	 * run is the requested workflow snapshot.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRunJson;

	/**
	 * prev_step is the previous step if present.
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRunJson;

	/**
	 * step reflects the step at the run's current position.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRunJson;

	/**
	 * next_step previews the step after the current one if available.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRunJson;
};

/**
 * Describes the message onboarding.v1.GetWorkflowRunResponse.
 * Use `create(GetWorkflowRunResponseSchema)` to create a new message.
 */
export const GetWorkflowRunResponseSchema: GenMessage<GetWorkflowRunResponse, { jsonType: GetWorkflowRunResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 3);

/**
 * SaveStepDataRequest captures draft data for a specific step.
 *
 * @generated from message onboarding.v1.SaveStepDataRequest
 */
export type SaveStepDataRequest = Message<"onboarding.v1.SaveStepDataRequest"> & {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId: string;

	/**
	 * step_id is the target step to update.
	 *
	 * @generated from field: string step_id = 2;
	 */
	stepId: string;

	/**
	 * data holds arbitrary draft payload for the step.
	 *
	 * @generated from field: onboarding.v1.StepData data = 3;
	 */
	data?: StepData;
};

/**
 * SaveStepDataRequest captures draft data for a specific step.
 *
 * @generated from message onboarding.v1.SaveStepDataRequest
 */
export type SaveStepDataRequestJson = {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId?: string;

	/**
	 * step_id is the target step to update.
	 *
	 * @generated from field: string step_id = 2;
	 */
	stepId?: string;

	/**
	 * data holds arbitrary draft payload for the step.
	 *
	 * @generated from field: onboarding.v1.StepData data = 3;
	 */
	data?: StepDataJson;
};

/**
 * Describes the message onboarding.v1.SaveStepDataRequest.
 * Use `create(SaveStepDataRequestSchema)` to create a new message.
 */
export const SaveStepDataRequestSchema: GenMessage<SaveStepDataRequest, { jsonType: SaveStepDataRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 4);

/**
 * SaveStepDataResponse returns the updated run and step snapshots.
 *
 * @generated from message onboarding.v1.SaveStepDataResponse
 */
export type SaveStepDataResponse = Message<"onboarding.v1.SaveStepDataResponse"> & {
	/**
	 * run reflects the workflow state after saving.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRun;

	/**
	 * step is the step snapshot with the persisted draft payload.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 2;
	 */
	step?: StepRun;
};

/**
 * SaveStepDataResponse returns the updated run and step snapshots.
 *
 * @generated from message onboarding.v1.SaveStepDataResponse
 */
export type SaveStepDataResponseJson = {
	/**
	 * run reflects the workflow state after saving.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRunJson;

	/**
	 * step is the step snapshot with the persisted draft payload.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 2;
	 */
	step?: StepRunJson;
};

/**
 * Describes the message onboarding.v1.SaveStepDataResponse.
 * Use `create(SaveStepDataResponseSchema)` to create a new message.
 */
export const SaveStepDataResponseSchema: GenMessage<SaveStepDataResponse, { jsonType: SaveStepDataResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 5);

/**
 * ExecuteStepRequest finalizes the current active step payload.
 *
 * @generated from message onboarding.v1.ExecuteStepRequest
 */
export type ExecuteStepRequest = Message<"onboarding.v1.ExecuteStepRequest"> & {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId: string;

	/**
	 * key is the key of the step run being completed.
	 *
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * payload holds the finalized structured data for the step data payload.
	 *
	 * @generated from field: google.protobuf.Any payload = 4;
	 */
	payload?: Any;
};

/**
 * ExecuteStepRequest finalizes the current active step payload.
 *
 * @generated from message onboarding.v1.ExecuteStepRequest
 */
export type ExecuteStepRequestJson = {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId?: string;

	/**
	 * key is the key of the step run being completed.
	 *
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * payload holds the finalized structured data for the step data payload.
	 *
	 * @generated from field: google.protobuf.Any payload = 4;
	 */
	payload?: AnyJson;
};

/**
 * Describes the message onboarding.v1.ExecuteStepRequest.
 * Use `create(ExecuteStepRequestSchema)` to create a new message.
 */
export const ExecuteStepRequestSchema: GenMessage<ExecuteStepRequest, { jsonType: ExecuteStepRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 6);

/**
 * ExecuteStepResponse returns the updated workflow and step context after completion.
 *
 * @generated from message onboarding.v1.ExecuteStepResponse
 */
export type ExecuteStepResponse = Message<"onboarding.v1.ExecuteStepResponse"> & {
	/**
	 * run is the workflow snapshot after completion.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRun;

	/**
	 * prev_step is the step that was completed
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRun;

	/**
	 * step is the the new current step;
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRun;

	/**
	 * next_step is the upcoming step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRun;
};

/**
 * ExecuteStepResponse returns the updated workflow and step context after completion.
 *
 * @generated from message onboarding.v1.ExecuteStepResponse
 */
export type ExecuteStepResponseJson = {
	/**
	 * run is the workflow snapshot after completion.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRunJson;

	/**
	 * prev_step is the step that was completed
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRunJson;

	/**
	 * step is the the new current step;
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRunJson;

	/**
	 * next_step is the upcoming step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRunJson;
};

/**
 * Describes the message onboarding.v1.ExecuteStepResponse.
 * Use `create(ExecuteStepResponseSchema)` to create a new message.
 */
export const ExecuteStepResponseSchema: GenMessage<ExecuteStepResponse, { jsonType: ExecuteStepResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 7);

/**
 * SkipStepRequest records a skip action with an optional reason.
 *
 * @generated from message onboarding.v1.SkipStepRequest
 */
export type SkipStepRequest = Message<"onboarding.v1.SkipStepRequest"> & {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId: string;

	/**
	 * key is the key of the step run being skipped.
	 *
	 * @generated from field: string key = 3;
	 */
	key: string;

	/**
	 * the payload for skipping a step
	 *
	 * @generated from field: onboarding.v1.SkipStepPayload payload = 4;
	 */
	payload?: SkipStepPayload;
};

/**
 * SkipStepRequest records a skip action with an optional reason.
 *
 * @generated from message onboarding.v1.SkipStepRequest
 */
export type SkipStepRequestJson = {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId?: string;

	/**
	 * key is the key of the step run being skipped.
	 *
	 * @generated from field: string key = 3;
	 */
	key?: string;

	/**
	 * the payload for skipping a step
	 *
	 * @generated from field: onboarding.v1.SkipStepPayload payload = 4;
	 */
	payload?: SkipStepPayloadJson;
};

/**
 * Describes the message onboarding.v1.SkipStepRequest.
 * Use `create(SkipStepRequestSchema)` to create a new message.
 */
export const SkipStepRequestSchema: GenMessage<SkipStepRequest, { jsonType: SkipStepRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 8);

/**
 * SkipStepResponse returns the updated workflow state after skipping.
 *
 * @generated from message onboarding.v1.SkipStepResponse
 */
export type SkipStepResponse = Message<"onboarding.v1.SkipStepResponse"> & {
	/**
	 * run is the workflow snapshot after skipping.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRun;

	/**
	 * prev_step is the step that was skipped
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRun;

	/**
	 * step is the new current step
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRun;

	/**
	 * next_step is the upcoming step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRun;
};

/**
 * SkipStepResponse returns the updated workflow state after skipping.
 *
 * @generated from message onboarding.v1.SkipStepResponse
 */
export type SkipStepResponseJson = {
	/**
	 * run is the workflow snapshot after skipping.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRunJson;

	/**
	 * prev_step is the step that was skipped
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRunJson;

	/**
	 * step is the new current step
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRunJson;

	/**
	 * next_step is the upcoming step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRunJson;
};

/**
 * Describes the message onboarding.v1.SkipStepResponse.
 * Use `create(SkipStepResponseSchema)` to create a new message.
 */
export const SkipStepResponseSchema: GenMessage<SkipStepResponse, { jsonType: SkipStepResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 9);

/**
 * LoadStepRequest identifies which step to load.
 *
 * @generated from message onboarding.v1.LoadStepRequest
 */
export type LoadStepRequest = Message<"onboarding.v1.LoadStepRequest"> & {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId: string;

	/**
	 * key is the key of the step run being loaded.
	 *
	 * @generated from field: string key = 2;
	 */
	key: string;
};

/**
 * LoadStepRequest identifies which step to load.
 *
 * @generated from message onboarding.v1.LoadStepRequest
 */
export type LoadStepRequestJson = {
	/**
	 * workflow_run_id identifies the parent run.
	 *
	 * @generated from field: string workflow_run_id = 1;
	 */
	workflowRunId?: string;

	/**
	 * key is the key of the step run being loaded.
	 *
	 * @generated from field: string key = 2;
	 */
	key?: string;
};

/**
 * Describes the message onboarding.v1.LoadStepRequest.
 * Use `create(LoadStepRequestSchema)` to create a new message.
 */
export const LoadStepRequestSchema: GenMessage<LoadStepRequest, { jsonType: LoadStepRequestJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 10);

/**
 * LoadStepResponse returns the requested step.
 *
 * @generated from message onboarding.v1.LoadStepResponse
 */
export type LoadStepResponse = Message<"onboarding.v1.LoadStepResponse"> & {
	/**
	 * the run is the workflow snapshot.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRun;

	/**
	 * prev_step is the previous step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRun;

	/**
	 * step is the requested step.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRun;

	/**
	 * next_step is the upcoming step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRun;
};

/**
 * LoadStepResponse returns the requested step.
 *
 * @generated from message onboarding.v1.LoadStepResponse
 */
export type LoadStepResponseJson = {
	/**
	 * the run is the workflow snapshot.
	 *
	 * @generated from field: onboarding.v1.WorkflowRun run = 1;
	 */
	run?: WorkflowRunJson;

	/**
	 * prev_step is the previous step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun prev_step = 2;
	 */
	prevStep?: StepRunJson;

	/**
	 * step is the requested step.
	 *
	 * @generated from field: onboarding.v1.StepRun step = 3;
	 */
	step?: StepRunJson;

	/**
	 * next_step is the upcoming step if any.
	 *
	 * @generated from field: onboarding.v1.StepRun next_step = 4;
	 */
	nextStep?: StepRunJson;
};

/**
 * Describes the message onboarding.v1.LoadStepResponse.
 * Use `create(LoadStepResponseSchema)` to create a new message.
 */
export const LoadStepResponseSchema: GenMessage<LoadStepResponse, { jsonType: LoadStepResponseJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 11);

/**
 * WorkflowRun summarizes the materialized onboarding workflow run.
 *
 * @generated from message onboarding.v1.WorkflowRun
 */
export type WorkflowRun = Message<"onboarding.v1.WorkflowRun"> & {
	/**
	 * id is the workflow run identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * workflow_template_id references the template instance backing the run.
	 *
	 * @generated from field: string workflow_template_id = 2;
	 */
	workflowTemplateId: string;

	/**
	 * template_key is the user-friendly key from the workflow template.
	 *
	 * @generated from field: string template_key = 3;
	 */
	templateKey: string;

	/**
	 * org_id is the organization undergoing onboarding.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId: string;

	/**
	 * user_id is the org admin user for this run.
	 *
	 * @generated from field: string user_id = 5;
	 */
	userId: string;

	/**
	 * status reflects the lifecycle state of the run.
	 *
	 * @generated from field: onboarding.v1.WorkflowRunStatus status = 6;
	 */
	status: WorkflowRunStatus;

	/**
	 * current_position is the index of the active visible step (1-based, zero if none).
	 *
	 * @generated from field: int32 current_position = 7;
	 */
	currentPosition: number;

	/**
	 * total_visible_steps is the count of visible steps materialized for the run.
	 *
	 * @generated from field: int32 total_visible_steps = 8;
	 */
	totalVisibleSteps: number;

	/**
	 * steps lists the ordered visible steps with their current state.
	 *
	 * @generated from field: repeated onboarding.v1.StepRun steps = 9;
	 */
	steps: StepRun[];

	/**
	 * created_at is when the run was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: Timestamp;

	/**
	 * updated_at is when the run was last modified.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: Timestamp;

	/**
	 * the workflow template used to create this run.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate workflow_template = 12;
	 */
	workflowTemplate?: WorkflowTemplate;

	/**
	 * template_type is the stable identifier for the workflow template type.
	 *
	 * @generated from field: onboarding.v1.WorkflowType template_type = 13;
	 */
	templateType: WorkflowType;

	/**
	 * completed_at is when the run was completed.
	 *
	 * @generated from field: google.protobuf.Timestamp completed_at = 14;
	 */
	completedAt?: Timestamp;
};

/**
 * WorkflowRun summarizes the materialized onboarding workflow run.
 *
 * @generated from message onboarding.v1.WorkflowRun
 */
export type WorkflowRunJson = {
	/**
	 * id is the workflow run identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * workflow_template_id references the template instance backing the run.
	 *
	 * @generated from field: string workflow_template_id = 2;
	 */
	workflowTemplateId?: string;

	/**
	 * template_key is the user-friendly key from the workflow template.
	 *
	 * @generated from field: string template_key = 3;
	 */
	templateKey?: string;

	/**
	 * org_id is the organization undergoing onboarding.
	 *
	 * @generated from field: string org_id = 4;
	 */
	orgId?: string;

	/**
	 * user_id is the org admin user for this run.
	 *
	 * @generated from field: string user_id = 5;
	 */
	userId?: string;

	/**
	 * status reflects the lifecycle state of the run.
	 *
	 * @generated from field: onboarding.v1.WorkflowRunStatus status = 6;
	 */
	status?: WorkflowRunStatusJson;

	/**
	 * current_position is the index of the active visible step (1-based, zero if none).
	 *
	 * @generated from field: int32 current_position = 7;
	 */
	currentPosition?: number;

	/**
	 * total_visible_steps is the count of visible steps materialized for the run.
	 *
	 * @generated from field: int32 total_visible_steps = 8;
	 */
	totalVisibleSteps?: number;

	/**
	 * steps lists the ordered visible steps with their current state.
	 *
	 * @generated from field: repeated onboarding.v1.StepRun steps = 9;
	 */
	steps?: StepRunJson[];

	/**
	 * created_at is when the run was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 10;
	 */
	createdAt?: TimestampJson;

	/**
	 * updated_at is when the run was last modified.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 11;
	 */
	updatedAt?: TimestampJson;

	/**
	 * the workflow template used to create this run.
	 *
	 * @generated from field: onboarding.v1.WorkflowTemplate workflow_template = 12;
	 */
	workflowTemplate?: WorkflowTemplateJson;

	/**
	 * template_type is the stable identifier for the workflow template type.
	 *
	 * @generated from field: onboarding.v1.WorkflowType template_type = 13;
	 */
	templateType?: WorkflowTypeJson;

	/**
	 * completed_at is when the run was completed.
	 *
	 * @generated from field: google.protobuf.Timestamp completed_at = 14;
	 */
	completedAt?: TimestampJson;
};

/**
 * Describes the message onboarding.v1.WorkflowRun.
 * Use `create(WorkflowRunSchema)` to create a new message.
 */
export const WorkflowRunSchema: GenMessage<WorkflowRun, { jsonType: WorkflowRunJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 12);

/**
 * StepRun represents an individual materialized step in the workflow.
 *
 * @generated from message onboarding.v1.StepRun
 */
export type StepRun = Message<"onboarding.v1.StepRun"> & {
	/**
	 * id is the step instance identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id: string;

	/**
	 * step_template_id references the underlying step template.
	 *
	 * @generated from field: string step_template_id = 2;
	 */
	stepTemplateId: string;

	/**
	 * workflow_run_id is the identifier of the workflow run this step belongs to.
	 *
	 * @generated from field: string workflow_run_id = 3;
	 */
	workflowRunId: string;

	/**
	 * key is the stable identifier for the step.
	 *
	 * @generated from field: string key = 4;
	 */
	key: string;

	/**
	 * display_name is the human-readable step title.
	 *
	 * @generated from field: string display_name = 5;
	 */
	displayName: string;

	/**
	 * position is the ordered index within the run (1-based).
	 *
	 * @generated from field: int32 position = 6;
	 */
	position: number;

	/**
	 * status captures the step lifecycle state.
	 *
	 * @generated from field: onboarding.v1.StepRunStatus status = 7;
	 */
	status: StepRunStatus;

	/**
	 * skippable indicates whether the step may be skipped.
	 *
	 * @generated from field: bool skippable = 8;
	 */
	skippable: boolean;

	/**
	 * data contains the draft or completed payload captured for the step.
	 *
	 * @generated from field: onboarding.v1.StepData data = 9;
	 */
	data?: StepData;

	/**
	 * started_at timestamp marks when the step became active.
	 *
	 * @generated from field: google.protobuf.Timestamp started_at = 11;
	 */
	startedAt?: Timestamp;

	/**
	 * completed_at timestamp marks when the step completed.
	 *
	 * @generated from field: google.protobuf.Timestamp completed_at = 12;
	 */
	completedAt?: Timestamp;

	/**
	 * hidden indicates whether the step was materialized but not shown.
	 *
	 * @generated from field: bool hidden = 13;
	 */
	hidden: boolean;

	/**
	 * created_at records when the step run was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: Timestamp;

	/**
	 * updated_at records the last modification time for the step run.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: Timestamp;

	/**
	 * the step template used to create this step run.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step_template = 16;
	 */
	stepTemplate?: StepTemplate;

	/**
	 * template_type is the stable identifier for the step template type.
	 *
	 * @generated from field: onboarding.v1.StepType template_type = 17;
	 */
	templateType: StepType;
};

/**
 * StepRun represents an individual materialized step in the workflow.
 *
 * @generated from message onboarding.v1.StepRun
 */
export type StepRunJson = {
	/**
	 * id is the step instance identifier.
	 *
	 * @generated from field: string id = 1;
	 */
	id?: string;

	/**
	 * step_template_id references the underlying step template.
	 *
	 * @generated from field: string step_template_id = 2;
	 */
	stepTemplateId?: string;

	/**
	 * workflow_run_id is the identifier of the workflow run this step belongs to.
	 *
	 * @generated from field: string workflow_run_id = 3;
	 */
	workflowRunId?: string;

	/**
	 * key is the stable identifier for the step.
	 *
	 * @generated from field: string key = 4;
	 */
	key?: string;

	/**
	 * display_name is the human-readable step title.
	 *
	 * @generated from field: string display_name = 5;
	 */
	displayName?: string;

	/**
	 * position is the ordered index within the run (1-based).
	 *
	 * @generated from field: int32 position = 6;
	 */
	position?: number;

	/**
	 * status captures the step lifecycle state.
	 *
	 * @generated from field: onboarding.v1.StepRunStatus status = 7;
	 */
	status?: StepRunStatusJson;

	/**
	 * skippable indicates whether the step may be skipped.
	 *
	 * @generated from field: bool skippable = 8;
	 */
	skippable?: boolean;

	/**
	 * data contains the draft or completed payload captured for the step.
	 *
	 * @generated from field: onboarding.v1.StepData data = 9;
	 */
	data?: StepDataJson;

	/**
	 * started_at timestamp marks when the step became active.
	 *
	 * @generated from field: google.protobuf.Timestamp started_at = 11;
	 */
	startedAt?: TimestampJson;

	/**
	 * completed_at timestamp marks when the step completed.
	 *
	 * @generated from field: google.protobuf.Timestamp completed_at = 12;
	 */
	completedAt?: TimestampJson;

	/**
	 * hidden indicates whether the step was materialized but not shown.
	 *
	 * @generated from field: bool hidden = 13;
	 */
	hidden?: boolean;

	/**
	 * created_at records when the step run was created.
	 *
	 * @generated from field: google.protobuf.Timestamp created_at = 14;
	 */
	createdAt?: TimestampJson;

	/**
	 * updated_at records the last modification time for the step run.
	 *
	 * @generated from field: google.protobuf.Timestamp updated_at = 15;
	 */
	updatedAt?: TimestampJson;

	/**
	 * the step template used to create this step run.
	 *
	 * @generated from field: onboarding.v1.StepTemplate step_template = 16;
	 */
	stepTemplate?: StepTemplateJson;

	/**
	 * template_type is the stable identifier for the step template type.
	 *
	 * @generated from field: onboarding.v1.StepType template_type = 17;
	 */
	templateType?: StepTypeJson;
};

/**
 * Describes the message onboarding.v1.StepRun.
 * Use `create(StepRunSchema)` to create a new message.
 */
export const StepRunSchema: GenMessage<StepRun, { jsonType: StepRunJson }> = /*@__PURE__*/ messageDesc(file_onboarding_v1_onboarding, 13);

/**
 * WorkflowRunStatus enumerates workflow run lifecycle states.
 *
 * @generated from enum onboarding.v1.WorkflowRunStatus
 */
export enum WorkflowRunStatus {
	/**
	 * @generated from enum value: WORKFLOW_RUN_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: WORKFLOW_RUN_STATUS_ACTIVE = 1;
	 */
	ACTIVE = 1,

	/**
	 * @generated from enum value: WORKFLOW_RUN_STATUS_COMPLETED = 2;
	 */
	COMPLETED = 2,

	/**
	 * @generated from enum value: WORKFLOW_RUN_STATUS_CANCELLED = 3;
	 */
	CANCELLED = 3,

	/**
	 * @generated from enum value: WORKFLOW_RUN_STATUS_ABORTED = 4;
	 */
	ABORTED = 4,
}

/**
 * WorkflowRunStatus enumerates workflow run lifecycle states.
 *
 * @generated from enum onboarding.v1.WorkflowRunStatus
 */
export type WorkflowRunStatusJson = "WORKFLOW_RUN_STATUS_UNSPECIFIED" | "WORKFLOW_RUN_STATUS_ACTIVE" | "WORKFLOW_RUN_STATUS_COMPLETED" | "WORKFLOW_RUN_STATUS_CANCELLED" | "WORKFLOW_RUN_STATUS_ABORTED";

/**
 * Describes the enum onboarding.v1.WorkflowRunStatus.
 */
export const WorkflowRunStatusSchema: GenEnum<WorkflowRunStatus, WorkflowRunStatusJson> = /*@__PURE__*/ enumDesc(file_onboarding_v1_onboarding, 0);

/**
 * StepRunStatus enumerates step lifecycle states.
 *
 * @generated from enum onboarding.v1.StepRunStatus
 */
export enum StepRunStatus {
	/**
	 * @generated from enum value: STEP_RUN_STATUS_UNSPECIFIED = 0;
	 */
	UNSPECIFIED = 0,

	/**
	 * @generated from enum value: STEP_RUN_STATUS_PENDING = 1;
	 */
	PENDING = 1,

	/**
	 * @generated from enum value: STEP_RUN_STATUS_ACTIVE = 2;
	 */
	ACTIVE = 2,

	/**
	 * @generated from enum value: STEP_RUN_STATUS_COMPLETED = 3;
	 */
	COMPLETED = 3,

	/**
	 * @generated from enum value: STEP_RUN_STATUS_SKIPPED = 4;
	 */
	SKIPPED = 4,

	/**
	 * @generated from enum value: STEP_RUN_STATUS_HIDDEN = 5;
	 */
	HIDDEN = 5,
}

/**
 * StepRunStatus enumerates step lifecycle states.
 *
 * @generated from enum onboarding.v1.StepRunStatus
 */
export type StepRunStatusJson = "STEP_RUN_STATUS_UNSPECIFIED" | "STEP_RUN_STATUS_PENDING" | "STEP_RUN_STATUS_ACTIVE" | "STEP_RUN_STATUS_COMPLETED" | "STEP_RUN_STATUS_SKIPPED" | "STEP_RUN_STATUS_HIDDEN";

/**
 * Describes the enum onboarding.v1.StepRunStatus.
 */
export const StepRunStatusSchema: GenEnum<StepRunStatus, StepRunStatusJson> = /*@__PURE__*/ enumDesc(file_onboarding_v1_onboarding, 1);

/**
 * OnboardingService exposes onboarding workflow operations.
 *
 * @generated from service onboarding.v1.OnboardingService
 */
export const OnboardingService: GenService<{
	/**
	 * GetOrCreateWorkflowRun returns an existing run for the selector or creates a new one.
	 *
	 * @generated from rpc onboarding.v1.OnboardingService.GetOrCreateWorkflowRun
	 */
	getOrCreateWorkflowRun: {
		methodKind: "unary";
		input: typeof GetOrCreateWorkflowRunRequestSchema;
		output: typeof GetOrCreateWorkflowRunResponseSchema;
	};
	/**
	 * GetWorkflowRun fetches a workflow run by id.
	 *
	 * @generated from rpc onboarding.v1.OnboardingService.GetWorkflowRun
	 */
	getWorkflowRun: {
		methodKind: "unary";
		input: typeof GetWorkflowRunRequestSchema;
		output: typeof GetWorkflowRunResponseSchema;
	};
	/**
	 * SaveStepData stores a partial draft payload without changing the step status.
	 *
	 * @generated from rpc onboarding.v1.OnboardingService.SaveStepData
	 */
	saveStepData: {
		methodKind: "unary";
		input: typeof SaveStepDataRequestSchema;
		output: typeof SaveStepDataResponseSchema;
	};
	/**
	 * ExecuteStep finalizes the active step, advances the run pointer, and returns updated state.
	 *
	 * @generated from rpc onboarding.v1.OnboardingService.ExecuteStep
	 */
	executeStep: {
		methodKind: "unary";
		input: typeof ExecuteStepRequestSchema;
		output: typeof ExecuteStepResponseSchema;
	};
	/**
	 * SkipStep skips the active step when skippable, capturing the provided reason.
	 *
	 * @generated from rpc onboarding.v1.OnboardingService.SkipStep
	 */
	skipStep: {
		methodKind: "unary";
		input: typeof SkipStepRequestSchema;
		output: typeof SkipStepResponseSchema;
	};
	/**
	 * LoadStep returns the requested step run by key or id and workflow_run_id
	 *
	 * @generated from rpc onboarding.v1.OnboardingService.LoadStep
	 */
	loadStep: {
		methodKind: "unary";
		input: typeof LoadStepRequestSchema;
		output: typeof LoadStepResponseSchema;
	};
}> = /*@__PURE__*/ serviceDesc(file_onboarding_v1_onboarding, 0);
